// extracted by mini-css-extract-plugin
export default {"Text":"BillingDocumentInformation_Text__x-RIP","Layout":"BillingDocumentInformation_Layout__j8p5c","Column":"BillingDocumentInformation_Column__zEZ8R"};